import { AppWidget } from '@launchpad';
import AppTableFilter from '@launchpad/components/crud/table/AppTableFilter';
import { AppPadding } from '@launchpad/components/widgets/AppPadding';
import Api from '@launchpad/logic/api/Api';
import ToastHelper from '@launchpad/util/ToastHelper';
import React from 'react';

const openUrl = (url: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

let _tableFilterReports: any = null;
const StipLogsReports = () => {
  const [downloading, setDownloading] = React.useState<boolean>(false);

  const triggerDownloadForDates = async (
    fromDate?: string,
    toDate?: string
  ) => {
    setDownloading(true);
    try {
      // const result = await Api.call('stats/totals', { filter });
      const result = (await Api.call(
        `admin/temenos/stip-log/download-report?fromDate=${fromDate}&toDate=${toDate}`,
        'GET'
      )) as { data: { url: string } };

      if (result?.data?.url) {
        openUrl(result.data.url);
      }
    } catch (e) {
      if (e && typeof e === 'object' && 'errors' in e) {
        (e.errors as Array<{ message: string }>).forEach((err) => {
          ToastHelper.show(err.message);
        });
      }
    } finally {
      setDownloading(false);
    }
  };

  const handleDownloadReport = (days: string) => {
    switch (days) {
      case 'today':
        triggerDownloadForDates(
          new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
          new Date(new Date().setHours(23, 59, 59, 999)).toISOString()
        );
        break;
      case 'last-7-days':
        triggerDownloadForDates(
          new Date(new Date().setDate(new Date().getDate() - 7)).toISOString(),
          new Date().toISOString()
        );
        break;
      case 'last-30-days':
        triggerDownloadForDates(
          new Date(new Date().setDate(new Date().getDate() - 30)).toISOString(),
          new Date().toISOString()
        );
        break;
      default:
        break;
    }
  };

  const triggerDownload = async () => {
    const rawParameters = {
      fromDate: _tableFilterReports
        .getFilter()
        .find((x) => x.name === 'fromDate')?.rawValue,
      toDate: _tableFilterReports.getFilter().find((x) => x.name === 'toDate')
        ?.rawValue,
    };

    const parsedParams = {
      fromDate: rawParameters.fromDate
        ? rawParameters.fromDate.toISOString()
        : undefined,
      toDate: rawParameters.toDate
        ? rawParameters.toDate.toISOString()
        : undefined,
    };

    triggerDownloadForDates(parsedParams.fromDate, parsedParams.toDate);
  };

  const getDownloadButton = () => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        style={{ marginTop: 20 }}
        onClick={() => triggerDownload()}
        className="button button-info"
        href="javascript:void(0);"
      >
        <i className="fa fa-fw fa-download" />{' '}
        {downloading ? 'downloading...' : 'Download report'}
      </a>
    );
  };

  const onFilter = (filter) => {
    console.log('filter', filter);
  };

  return (
    <AppWidget title="Download report">
      <AppPadding>
        <div
          style={{
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            width: '100%',
          }}
        >
          <button
            onClick={() => handleDownloadReport('today')}
            className="button button-default"
            style={{ flex: 1 }}
            type="button"
          >
            Download report for today
          </button>
          <button
            onClick={() => handleDownloadReport('last-7-days')}
            className="button button-default"
            style={{ flex: 1 }}
            type="button"
          >
            Download report for last 7 days
          </button>
          <button
            onClick={() => handleDownloadReport('last-30-days')}
            className="button button-default"
            style={{ flex: 1 }}
            type="button"
          >
            Download report for last 30 days
          </button>
        </div>
        <hr />
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <h4>Download custom report</h4>
          <AppTableFilter
            onInit={(comp) => {
              _tableFilterReports = comp;
            }}
            filterClass="non-flexible-filter"
            verticalCalendarPosition="bottom"
            filter={[
              {
                name: 'fromDate',
                type: 'datetime',
                field: 'created',
                operation: 'gte',
                label: 'From Date',
              },
              {
                name: 'toDate',
                type: 'datetime',
                field: 'created',
                operation: 'lte',
                label: 'To Date',
              },
            ]}
            noSearchButton
            style={{ marginTop: 10, marginBottom: 10 }}
            onFilter={(filter) => onFilter(filter)}
          />
          {getDownloadButton()}
        </div>
      </AppPadding>
    </AppWidget>
  );
};

export default StipLogsReports;
